import { GET_TRIPS_NEW_REQUEST, GET_LOADS_BETWEEN_CITY, TRIP_DETAILS_UPDATE, GET_TRIPS_STATUS } from '../actions/Trips';

const INIT_STATE = {
  newrequest: {
    trips: [],
    total_count: 0,
  },
  tripstatus: {
    trips: [],
    total_count: 0,
  },
  tripdetails: {
    lanes: [],
    user: {},
    selected_loads: [],
  },
  lanesLoads: {}, // store data as lanes Index wise eg. {0: {loads: [], total_count: 0} }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TRIPS_NEW_REQUEST: {
      return {
        ...state,
        newrequest: { ...state.newrequest, ...action.payload },
      };
    }

    // create trip
    case TRIP_DETAILS_UPDATE: {
      return {
        ...state,
        tripdetails: { ...state.tripdetails, ...action.payload },
      };
    }

    // update loads
    case GET_LOADS_BETWEEN_CITY: {
      const lanesLoads = { ...state.lanesLoads };
      lanesLoads[action.payload.laneIndex] = {
        loads:
          action.payload.start !== 0
            ? [...lanesLoads[action.payload.laneIndex].loads.slice(0, action.payload.start), ...action.payload.data.loads]
            : action.payload.data.loads,
        total_count: action.payload.data.total_count,
      };
      return {
        ...state,
        lanesLoads: lanesLoads,
      };
    }

    // trip status
    case GET_TRIPS_STATUS: {
      return {
        ...state,
        tripstatus: { ...state.tripstatus, ...action.payload },
      };
    }

    default:
      return state;
  }
};
